window.translations = window.translations || {};

(function (translations) {
    'use strict';

    translations['es'] = {
        //GENERICS
        'CLOSE': 'Cerrar',
        'ERROR': 'Error',
        'OK': 'Ok',
        'REMOVE': 'Eliminar',
        'CANCEL': 'Cancelar',
        'ON': 'Sí',
        'YES': 'Sí',
        'OFF': 'No',
        'LOADING': 'Cargando',
        'LOADING2': 'Cargando datos...',
        'MORE_ELEMENTS': 'Más elementos',
        'REQUIRED': 'Requerido',
        'HOME': 'Inicio',
        'POWERED_BY': 'Creado con',
        'HERE': 'aquí',
        'CORPORATE': 'www.upplication.com',

        //ERRORS
        'NETWORK_ERROR': 'Ups! Parece que hay un error. Inténtalo de nuevo o contacta con tu administrador.',
        'CONTACT_CREATOR': 'En caso de duda contacte con el administrador.',

        //NAV BAR
        //Langs
        'LANG': 'Idioma',
        'SPANISH': 'Español',
        'ENGLISH': 'Inglés',
        'SUAJILI': 'Suajili',

        //PWA advise
        'PWA.ICON': 'Añadir a página de inicio',
        'PWA.ADD': 'Para instalar como una App pincha en este icono de la barra del navegador y elige la opción: ',

        //ABOUT
        'ABOUT.INFO.WHO': 'Quiénes somos',
        'ABOUT.INFO.CONTACT': 'Contacto',
        'ABOUT.INFO.LOCATION': 'Localización',
        'ABOUT.INFO.SOCIAL_NETWORK': 'Redes sociales',
        'ABOUT.INFO.POLICY' : 'Condiciones legales',

        // LOADERS
        'LOADER.APPLOAD.TEXT': 'Cargando...',
        'LOADER.APPUPDATE.TEXT': '¡Actualizando App!',

        //LOGIN STUFF
        'LOGIN.USER': 'Usuario',
        'LOGIN.EMAIL': 'Email',
        'LOGIN.NAME': 'Nombre',
        'LOGIN.PHONE': 'Teléfono',
        'LOGIN.SURNAME': 'Apellido',
        'LOGIN.DNI': 'DNI',
        'LOGIN.CAPTCHA': 'Captcha',
        'LOGIN.PASSWORD': 'Contraseña',
        'LOGIN.PASSWORD.CONFIRM': 'Confirmar Contraseña',
        'LOGIN.REMEMBER': 'Recordar',
        'LOGIN.SIGNIN': 'Iniciar Sesión',
        'LOGIN.SIGNOUT': 'Cerrar Sesión',
        'LOGIN.GOTOLOGIN': 'Ir al login',
        'LOGIN.FAIL.TITLE': 'Error',
        'LOGIN.FAIL': 'Error en usuario o contraseña.',
        'LOGIN.FAIL.MSG': 'Lo sentimos, tu nombre de usuario y clave son incorrectos. Por favor, inténtelo de nuevo o contacte con tu administrador.',
        'LOGIN.NEEDED.TITLE': 'Atención! Necesitas iniciar sesión para ver esta sección.',
        'LOGIN.NEEDED.MSG': 'Por favor, haz click en login e inicia sesión.',
        'LOGIN.RESTORE_PASSWORD': '¿No recuerdas tu contraseña? Restáurala pinchando',

        //COMMONS FOR REGISTER & ACCOUNT
        'LOGIN.ERR.VALIDATION': 'Información incorrecta:',
        'LOGIN.ERR.VALIDATION.MSG': 'Los campos marcados son erróneos. Por favor, inténtalo de nuevo.',

        //ACCOUNT
        'LOGIN.ACCOUNT': 'Mi cuenta',
        'LOGIN.ACCOUNT.HEADER': 'Tu información de cuenta',
        'LOGIN.ACCOUNT.UPDATE-ACCOUNT': 'Guardar',
        'LOGIN.ACCOUNT.DELETE-ACCOUNT': 'Eliminar cuenta',
        'LOGIN.ACCOUNT.OK': 'Tu información ha sido guardada',
        'LOGIN.ACCOUNT.ERR.SERVER': 'Error guardando tus datos.',
        'LOGIN.ACCOUNT.ERR.SERVER.MSG.DEFAULT': 'Error realizando el registro',

        'LOGIN.ACCOUNT.DELETE.MODAL.TITLE': 'Eliminación de cuenta',
        'LOGIN.ACCOUNT.DELETE.MODAL1.MSG': 'Una vez que elimines tu cuenta no podrás recuperarla',
        'LOGIN.ACCOUNT.DELETE.MODAL2.MSG': '¿Estás seguro?, ¡Tienes envíos pendientes, los perderás!',
        'LOGIN.ACCOUNT.DELETE.MODAL.CONFIRM': 'Sí, eliminar',
        'LOGIN.HAVE_ACCOUNT': '¿No estás registrado? Regístrate pinchando',

        //REGISTER
        'LOGIN.REGISTER': 'Registro',
        'LOGIN.REGISTER.HEADER': '¡Registra tu nueva cuenta!',
        'LOGIN.REGISTER.TERMS.TEXT': 'Acepto los ',
        'LOGIN.REGISTER.TERMS.LINK': 'términos y condiciones',
        'LOGIN.REGISTER.CREATE-ACCOUNT': 'Crear mi cuenta',
        'LOGIN.REGISTER.OK': ' ¡Ya te has registrado!',
        'LOGIN.REGISTER.OK.MSG': 'Te mandaremos un email con un link de activación para verificar tu cuenta.',
        'LOGIN.REGISTER.ERR.SERVER': 'Error registrándote.',
        'LOGIN.REGISTER.ERR.SERVER.MSG.DUPLICATED-EMAIL': 'Este email ya ha sido registrado',
        'LOGIN.REGISTER.ERR.SERVER.MSG.DEFAULT': 'Ha ocurrido un error procesando tu registro',
        'LOGIN.REGISTER.SUCCESS.MSG': 'Te has registrado correctamente.',

        //ACTIVATE
        'LOGIN.ACTIVATE.HEADER': 'Activa tu cuenta',
        'LOGIN.ACTIVATE.TEXT': 'Te hemos enviado un email con un código de 4 digitos para que actives tu cuenta',
        'LOGIN.REGISTER.RESEND-ACTIVATE-ACCOUNT': 'Si no has recibido ningún correo. Pincha aquí para volver a enviartelo',
        'LOGIN.REGISTER.ACTIVATE-ACCOUNT': '¡Activar!',
        'LOGIN.ACTIVATE.ERR.SERVER': 'No se ha podido realizar la activación',
        'LOGIN.RESEND.ACTIVATE.ERR.SERVER': 'No se ha podido reenviar la activación',

        //CART (module)
        'ADDRESS.NAME': 'Calle',
        'ADDRESS.POSTAL-CODE': 'Código Postal',
        'ADDRESS.CITY': 'Ciudad',
        'ADDRESS.STATE': 'Provincia',
        'ADDRESS.COUNTRY': 'País',
        'ADDRESS.CIF' : 'CIF',
        'ADDRESS.PHONE' : 'Teléfono',
        'ADDRESS.PERSON' : 'Soy un particular',
        'ADDRESS.BUSINESS' : 'Soy una empresa',
        'ADDRESS.VAT' : 'VAT ID',
        'ADDRESS.DNI' : 'DNI',
        'ADDRESS.NIF' : 'NIF',
        'ADDRESS.ADDRESSEE' : 'Destinatario',
        'ADDRESS.BUSINESS_NAME' : 'Razón Social',

        //CATALOG (module)
        'CATALOG.PRODUCTS.SHOW.BTN.BLOCK' : 'Mostrar en bloque',
        'CATALOG.PRODUCTS.SHOW.BTN.INLINE' : 'Mostrar en linea',

        //BANNER
        'FCMPLUGIN.BANNER' : 'Estamos terminando de sincronizar tu app, espere unos segundos...',

        // ORDERS
        'MY-ORDERS.MENU': 'Pedidos',
        'MY-ORDERS.TITLE': 'Pedidos',
        'MY-ORDERS.DATE': 'Fecha',
        'MY-ORDERS.PRICE': 'Precio',
        'MY-ORDERS.SENT': 'Enviado',


        'MY-ORDERS.SHIPPING': 'Dirección de envío',
        'MY-ORDERS.BILLING': 'Dir. de facturación',
        'MY-ORDERS.OBSERVATIONS': 'Observaciones',

        'MY-ORDERS.AMOUNT': 'Cantidad',
        'MY-ORDERS.PRODUCT': 'Producto',
        'MY-ORDERS.SIZE': 'Tamaño',
        'MY-ORDERS.COLOR': 'Color',
        'MY-ORDERS.UNIT-PRICE': 'Precio',
        'MY-ORDERS.TOTAL-PRICE': 'Total',
        'MY-ORDERS.SHIPPING-CHARGES': 'Gastos de envío',
        'MY-ORDERS.PAYMENT_METHOD': 'Método de pago',
        'MY-ORDERS.PAID_WITH_PAYPAL': 'Pago con PayPal',
        'MY-ORDERS.PAID_WITH_REDSYS': 'Pago con Tarjeta de crédito',
        'MY-ORDERS.PAY_ON_DELIVERY': 'Pago contra-reembolso',
        'MY-ORDERS.PAY_AT_STORE': 'Pago en tienda',
        'MY-ORDERS.PAY_WIRE_TRANSFER': 'Pago por transferencia',
        'MY-ORDERS.NO-ORDER': 'No hay ningún pedido',

        // RESTORE
        'RESTORE.TITLE': 'Restaurar contraseña',
        'RESTORE.FAIL.MSG': 'No se ha podido encontrar un usuario asociado al email introducido. Inténtelo de nuevo.',
        'RESTORE.FAIL': 'Error',
        'RESTORE.EMAIL': 'Introduce tu Email',
        'RESTORE.EMAIL.SAMPLE': 'E.j.: pepe@gmail.com',
        'RESTORE.SUBMIT': 'Restaurar',
        'RESTORE.SUCCESS.MSG': 'Se ha enviado un correo a tu cuenta para que puedas restaurar tu contraseña.',

        // CHANGE PASSWORD
        'CHANGE_PASSWORD.BTN': 'Cambiar contraseña',
        'CHANGE_PASSWORD.TITLE': 'Nueva contraseña',
        'CHANGE_PASSWORD.FAIL.MSG': 'Ha ocurrido un error, no hemos podido cambiar tu contraseña.',
        'CHANGE_PASSWORD.FAIL': 'Error',
        'CHANGE_PASSWORD.PASSWORD': 'Contraseña',
        'CHANGE_PASSWORD.PASSWORD_REPEAT': 'Repetir contraseña',
        'CHANGE_PASSWORD.SUBMIT': 'Cambiar contraseña',
        'CHANGE_PASSWORD.SUCCESS.MSG': 'Se ha cambiado correctamente tu contraseña.',


        //HTTP ERRORS CODES

        'HTTP.ERROR.childupp.not-exists': 'La aplicación no existe',
        'HTTP.ERROR.childupp.out-of-service': 'La aplicación está dada de baja.',
        'HTTP.ERROR.childupp.trial.expired': 'La aplicación está temporalmente fuera de servicio.',
        'HTTP.ERROR.payment.blocked': 'La aplicación está temporalmente fuera de servicio.',
        'HTTP.ERROR.user.email.in-use': 'El email indicado ha sido registrado.',
        'HTTP.ERROR.user.code.not-valid': 'El código de activación es inválido',
        'HTTP.ERROR.user.not-exists': 'El usuario no existe',
        // FIXME: translate or remove (maybe not have sense to send this info from the server side)
        'HTTP.ERROR.user.childupp.not-match': 'translate!!',
        'HTTP.ERROR.product.not-found': 'translate!!',
        'HTTP.ERROR.empty.basket': 'translate!!',
        'HTTP.ERROR.shippingcharges.not-found': 'translate!!',
        'HTTP.ERROR.user.data.incomplete': 'translate!!',
        'HTTP.ERROR.user.status.waiting': 'translate!!',
        'HTTP.ERROR.payment.data.not-found': 'translate!!',
        'HTTP.ERROR.order.not-exists': 'translate!!',
        'HTTP.ERROR.order.childupp.not-match': 'translate!!',
        'HTTP.ERROR.order.not-waiting': 'translate!!',
        'HTTP.ERROR.catalog.contact-info.not-found': 'translate!!',
        'HTTP.ERROR.catalog.promotion.not-found': 'translate!!',
        'HTTP.ERROR.catalog.category.not-found': 'translate!!',

        'HTTP.ERROR.DEFAULT': 'Ha ocurrido un error procesando tu petición. Por favor, inténtalo de nuevo o contacta con tu administrador.'
    };

})(window.translations);



// WEBPACK FOOTER //
// ./src/app/common/lang/lang_es.js